/** Отображаемые названия моделей детекции (RU). */
export const getModelDisplayName = (modelName: string): string => {
  const key = (modelName || '').trim().toLowerCase();
  const modelTranslations: Record<string, string> = {
    multiple_rtsp: 'Машины и люди',
    license_plate_recognition: 'Распознавание гос. номеров',
    lpd: 'Номерной знак',
    people: 'Люди',
    person: 'Люди',
    car: 'Машины',
    vehicle: 'Машины',
    bus: 'Автобусы',
    truck: 'Грузовики',
    police: 'Полиция',
    ambulance: 'Скорая помощь',
    firetruck: 'Пожарная машина',
    smoking: 'Курение',
    smoking_detector: 'Курение',
    smoking_detector_v2: 'Курение v2',
    garbage_truck_detector: 'Мусоровоз',
    garbage_truck: 'Мусоровоз',
    tractor_detector: 'Трактор',
    tractor: 'Трактор',
    fire_and_smoke_detector: 'Огонь и дым',
    fire: 'Огонь',
    smoke: 'Дым',
    emergency_car_detector: 'Спецтранспорт',
    cigarette: 'Курение',
    utrau_staff_detector: 'Детекция персонала',
    absence: 'Отсутствие',
    absence_end: 'Отсутствие завершено',
    covered: 'Камера закрыта',
    turned: 'Камера повёрнута',
    restored: 'Камера снова в норме',
    server: 'Персонал',
    staff: 'Персонал',
  };

  return modelTranslations[key] || modelName;
};

/** Заголовок события для ленты на главной. */
export const getEventTitle = (modelName: string): string => {
  const key = (modelName || '').trim().toLowerCase();
  const titles: Record<string, string> = {
    people: 'Обнаружен человек',
    person: 'Обнаружен человек',
    multiple_rtsp: 'Обнаружены объекты',
    car: 'Обнаружен автомобиль',
    vehicle: 'Обнаружен автомобиль',
    license_plate_recognition: 'Распознан гос. номер',
    lpd: 'Распознан гос. номер',
    smoking: 'Обнаружено курение',
    smoking_detector: 'Обнаружено курение',
    smoking_detector_v2: 'Обнаружено курение',
    fire_and_smoke_detector: 'Обнаружен огонь или дым',
    fire: 'Обнаружен огонь',
    smoke: 'Обнаружен дым',
    garbage_truck: 'Обнаружен мусоровоз',
    garbage_truck_detector: 'Обнаружен мусоровоз',
    tractor: 'Обнаружен трактор',
    tractor_detector: 'Обнаружен трактор',
    utrau_staff_detector: 'Обнаружен персонал',
    absence: 'Зафиксировано отсутствие',
    absence_end: 'Период отсутствия завершён',
    covered: 'Камера закрыта',
    turned: 'Камера повёрнута',
    restored: 'Камера снова в норме',
    server: 'Обнаружен персонал',
    staff: 'Обнаружен персонал',
  };

  return titles[key] || `Детекция: ${getModelDisplayName(modelName)}`;
};
